module.exports = __webpack_public_path__ + "img/user.e71dc40f.svg";